import * as UI from "@accurx/design";
import { zinc } from "domains/inbox/theme/colors";
import styled from "styled-components";

export const NoResults = styled(UI.Text).attrs({ colour: "white" })`
    font-style: italic;
    font-size: 0.875rem;
    color: ${zinc.tint70};
`;
